import React, { useCallback } from "react";
import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Slider } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./LatestAvailableValue.styles";
import type { ILatestAvailableValueProps } from "./LatestAvailableValue.types";

export const LatestAvailableValue: FC<ILatestAvailableValueProps> = (props) => {
  const classes = useStyles();
  const { checked, onChange, disabled } = props;

  const handleChangeChecked = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange(checked);
    },
    [onChange]
  );

  return (
    <FormGroup>
      <FormControlLabel
        disabled={disabled}
        control={
          <Checkbox
            classes={{ root: classes.rootCheckbox }}
            color="primary"
            checked={checked}
            onChange={handleChangeChecked}
            name="latestAvalilable"
            disabled={disabled}
          />
        }
        label={
          <div className={classes.labelCheck}>
            <span>latest available value</span>
          </div>
        }
      />
    </FormGroup>
  );
};
